export const sessionItemType = 'SESSION_ITEM';
export const trackItemType = 'TRACK_ITEM';
export const defaultTrackType = 'general';
export const trackType = 'program';
